// extracted by mini-css-extract-plugin
module.exports = {"container":"ndD8Lk9-7gVqcWk6JiE20"};